import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataGridView, useSub } from "@neumetric/blueprint-lib/components";
import { mitigatorActions, getThreatTypesByStatus } from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const threatTypeColumns = [
  {
    dataIndex: "threat_type_id",
    typeRepresentation: "LINK",
    title: "Threat Type ID",
    width: "30%",
  },
  {
    dataIndex: "type",
    typeRepresentation: "TEXT",
    title: "Threat Type",
    width: "70%",
    showTooltip: true,
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "active";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorThreatTypeTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _ref = React.useRef(null);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });
  const threatTypesList =
    useSelector(
      getThreatTypesByStatus.bind(null, state.activeSubmenu.toLowerCase())
    ) || [];

  useEffect(() => {
    fetchThreatTypes();
  }, []);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };

    options.columns = threatTypeColumns;
    options.className = "w-800-px";

    return options;
  }, [state.activeSubmenu]);

  const fetchThreatTypes = () => {
    dispatch(mitigatorActions.fetchThreatTypes());
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchThreatTypes();
  };

  return (
    <div
      className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`}
      ref={_ref}
    >
      <DataGridView
        columns={dvgOptions.columns}
        dataSource={threatTypesList.map((threat_typs) => ({
          threat_type_id: threat_typs.threat_type_id || "",
          type: threat_typs.threat_type || "",
          id: threat_typs.id || "",
        }))}
        pagination={{
          pageSize: 9,
          totalCount: threatTypesList?.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          if (column.dataIndex === "threat_type_id") {
            return {
              onLinkClick: () => {
                const p = new URLSearchParams(window.location.search);
                p.set("tab", (state.activeSubmenu || "active").toLowerCase());
                p.set("open", "view-panel");
                p.set("id", record.id);
                p.set("_ts", Date.now());

                navigate(`${window.location.pathname}?${p.toString()}`);
              },
            };
          }
          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">
            There are no {state.activeSubmenu.toLowerCase()} threat types right
            now!
          </span>
        }
      />
    </div>
  );
};
